import React from "react";
import { Button, Container, Row, Col, Form, Modal, ToggleButton, Dropdown, ButtonGroup } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';
import SiteDetails from "./SiteDetails";
import SearchScreen from "./SearchScreen";
import Locale from "../../locale/Locale";
import * as PSLib from 'poolside-js-lib';
import AlertHelper from '../helpers/alert';

export default class AlertsScreen extends SearchScreen {
    
    pathPrefix = "/alerts";
    methodName = "Professional.getAlerts";
    searchEnabled = false;
    addEnabled = false;
    detailComponent = SiteDetails;
    stateTypes = [ 'OPEN', 'CLOSED' ];
    selectedStates = [ 'OPEN' ];
    selectedTypes = [];

    setFilters() {
        if (this.selectedTypes.length > 0)
            this.state.extraParams.types = this.selectedTypes;
        else 
            delete this.state.extraParams.types;
        if (this.selectedStates.length > 0)
            this.state.extraParams.states = this.selectedStates;
        else 
            delete this.state.extraParams.states;
        this.setState({});
        this.refreshPushed();
    }

    filterControls = function() { 
        let msOptions = Object.values(PSLib.Alert.AlertType).sort().map(typ => {
            return {
                value: typ,
                label: typ.toLowerCase().replaceAll('_', ' '),
                selected: this.selectedTypes.indexOf(typ) !== -1
            };
        });
        let buttonStyle = {
            display: 'block', marginRight: 10, marginBottom: 10, width: '95%'
        };
        const typesText = this.selectedTypes.length === 0 || this.selectedTypes.length === Object.values(PSLib.Alert.AlertType) ?
            "All" :
            this.selectedTypes.length
        ;
        const statesText = this.selectedStates.length === 0 || this.selectedStates.length === this.stateTypes.length ?
            "All" :
            this.selectedStates.length
        ;
        return (
            <div style={{ flex: 1, flexDirection: 'column' }}>
                <Dropdown style={{ display: 'inline-block', marginRight: 10 }}>
                    <Dropdown.Toggle id="dropdown-basic">
                        Alert Types ({ typesText })
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ maxHeight: 400, width: 300, overflowY: 'auto', padding: 10 }}>
                        <Button key="selectedTypes-all" 
                            variant={ this.selectedTypes.length === 0 || this.selectedTypes.length === Object.values(PSLib.Alert.AlertType).length ? "primary" : "secondary" } 
                            style={ buttonStyle }
                            onClick={ () => {
                                if (this.selectedTypes.length === Object.values(PSLib.Alert.AlertType).length) {
                                    this.selectedTypes = [];
                                } else {
                                    this.selectedTypes = [ ...Object.values(PSLib.Alert.AlertType) ];
                                }
                                this.setFilters();
                            }}
                        >All</Button>
                        { msOptions.map(typ => (
                            <Button 
                                key={"selectedTypes-" + typ.value} 
                                variant={ this.selectedTypes.indexOf(typ.value) !== -1 ? "primary" : "secondary" } 
                                style={ buttonStyle }
                                onClick={ () => {
                                    let index = this.selectedTypes.indexOf(typ.value);
                                    if (index !== -1) {
                                        this.selectedTypes.splice(index, 1);
                                    } else {
                                        this.selectedTypes.push(typ.value);
                                    }
                                    this.setFilters();
                                }}>{typ.label}</Button>
                        )) }
                    </Dropdown.Menu>
                </Dropdown>
                <Dropdown style={{ display: 'inline-block', marginRight: 10 }}>
                    <Dropdown.Toggle id="dropdown-basic">
                        States ({ statesText })
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ maxHeight: 400, width: 300, overflowY: 'auto', padding: 10 }}>
                        <Button key="selectedStates-all" 
                            variant={ this.selectedStates.length === this.stateTypes.length ? "primary" : "secondary" } 
                            style={ buttonStyle }
                            onClick={ () => {
                                if (this.selectedStates.length === Object.values(PSLib.Alert.AlertType).length) {
                                    this.selectedStates = [];
                                } else {
                                    this.selectedStates = [ ...this.stateTypes ];
                                }
                                this.setFilters();
                            }}
                        >All</Button>
                        { this.stateTypes.map(typ => (
                            <Button 
                                key={"selectedStates-" + typ} 
                                variant={ this.selectedStates.indexOf(typ) !== -1 ? "primary" : "secondary" } 
                                style={ buttonStyle }
                                onClick={ () => {
                                    let index = this.selectedStates.indexOf(typ);
                                    if (index !== -1) {
                                        this.selectedStates.splice(index, 1);
                                    } else {
                                        this.selectedStates.push(typ);
                                    }
                                    this.setFilters();
                                }}>{typ}</Button>
                        )) }
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        )
    };

    componentDidMount() {
        let params = context.getQueryParams();
        this.state.extraParams.ignoreDisconnect = true;
        if (Object.keys(params).length > 0) {
            Object.assign(this.state.extraParams, params);
        }
        super.componentDidMount();
    }

    renderHeader() {
        return (
            <ListGroup.Item  
                key={ "header" } 
                className="listItem"
                style={{ fontWeight: 'bold' }}
            >
                <div style={{ float: "left", marginRight: "20px", minWidth: 150 }} key={"alert_created_"} >
                    { Locale.gettext("Created") }
                </div>
                <div style={{ float: "left", marginRight: "20px", minWidth: 100 }} key={"site_info_right_"} >
                    { Locale.gettext("State") }
                </div>
                <div style={{ float: "left", width: "20%" }} key={"site_info_"} >
                    { Locale.gettext("Site") } / { Locale.gettext("Owner") }
                </div>
                <div style={{ float: "left", width: "30%" }} key={"alert_type_"} >
                    { Locale.gettext("Type") }
                </div>
            </ListGroup.Item> 
        )
    }

    itemRenderer(item) {
        var link = item.site ? "/sites/" + item.site?.uuid + "/Alerts" : "/devices/" + item.device?.uuid + "/Alerts";
        let alerttypename = AlertHelper.translateAlertType(item.type);
        return (
            <ListGroup.Item action 
                key={ item.uuid } 
                onClick={ () => context.navigate(link, item.site ? "Site " + item.site.name : "Device " + item.device.uuid) }
                className="listItem"
            >
                <div style={{ float: "left", marginRight: "20px", minWidth: 150 }} key={"alert_created_" + item.serverId} >
                    { this.calcTime(item.created) }
                </div>
                <div style={{ float: "left", marginRight: "20px", minWidth: 100 }} key={"site_info_right_" + item.uuid} >
                    { item.state }
                </div>
                <div style={{ float: "left", width: "20%" }} key={"site_info_" + item.uuid} >
                    { item.site?.name || "Device: " + item.device?.uuid } 
                </div>
                <div style={{ float: "left", width: "30%" }} key={"alert_type_" + item.uuid} >
                    { alerttypename }
                </div>
            </ListGroup.Item> 
        )
    }
    
}